<script>
  export let value="";
  export let items = []
  export let labelField
  export let valueField
  export let maxItems=5
  let activeIndex = 0
  let hidden = true
  let inputvalue 

  const search = (query="",data=[])=>{
    if(query){
      let matchany = new RegExp("^(?=.*"+query.replace(/\s/,")(?=.*")+").*$","i")
      let matchstart = new RegExp("^"+query+".*$","i")
      return (data
        .filter( item =>JSON.stringify(item).match(matchany) ) // match all containing
        .sort((a,b)=>{ // sort by those which match start
          let m1 = a[labelField].match(matchstart)
          let m2 = b[labelField].match(matchstart)
          return (m1 ? 1 : 0 ) > (m2 ? 1 : 0) ? -1 : 1
        })
      )
    }else if(data){
      return data.slice()
    }
  }

  let options = search(inputvalue,items).slice(0,maxItems)

  function handleKey(e){
    if(e.key=="ArrowDown" && activeIndex < options.length-1){
      activeIndex+=1
    }
    if(e.key=="ArrowUp" && activeIndex > 0){
      activeIndex-=1
    }
    if(e.key=="Enter"){
      inputvalue = options[activeIndex][labelField]
      value = options[activeIndex][valueField]
      e.target.blur()
    }
    if(activeIndex > options.length-1){
      activeIndex = options.length-1
    }
  }

  function getFromItems(items){
    if(!hidden){
      return inputvalue
    }
    return items.filter( item => item[valueField] == value).length ? items.filter( item => item[valueField] == value)[0][labelField] : ""
  }

  $: inputvalue = getFromItems(items)


</script>

<div class="autocomplete">
  <input type="text" class="form-input" bind:value={inputvalue} on:focus={(e)=> hidden=false} on:blur={(e)=>{ hidden=true; if(inputvalue == ""){value = null}}} on:keydown={handleKey} on:input={(e)=> options = search(e.target.value,items).slice(0,maxItems)}/>
  {#if inputvalue && inputvalue.length > 0 && !hidden}
    <div class="optionlist">
      {#each options as option,idx}
        <div 
          on:mouseover={(e)=> activeIndex=idx}
          on:mousedown={(e)=>{ 
            inputvalue = options[idx][labelField]; 
            value = options[activeIndex][valueField]
          }}
          class={activeIndex == idx ? "active" : ""}>
            {option[labelField]}
        </div>
      {/each}
    </div>
  {/if}
</div>

<style>
  .autocomplete{
    width:100%;
    position:relative
  }
  .optionlist{
    position:absolute;
    left:0;
    right:0;
    top:35px;
    background:white;
    box-shadow:0 1px 5px rgba(0,0,0,0.3);
    z-index:1001;
  }
  .optionlist > div{
    padding:7px 10px;
    cursor:pointer;
  }
  .optionlist > div.active{
    background:#eee;
  }
</style>